import {useFormik} from "formik";
import {useAppDataStore} from "@/mobx/appDataStore.jsx";
import {useState} from "react";
import {useNavigate} from "react-router-dom";
import ForcedPasswordChange from "./forcedPasswordChange";

export default function Auth() {
  const appDataStore = useAppDataStore()
  const navigate = useNavigate()

  const [loginError, setLoginError] = useState('')
  const [showForcedPasswordChange, setShowForcedPasswordChange] = useState(false)
  const formik = useFormik({
    initialValues: {email: '', password: ''},
    onSubmit: async (values) => {
      try {
        const loginRes = await appDataStore.login(values)
        // Verificar si el usuario debe cambiar contraseña
        if (loginRes.user?.passwordChanged === false) {
          setShowForcedPasswordChange(true)
        } else {
          navigate('/app')
        }
      } catch (err) {
        setLoginError(err.message)
      }
    }
  })

  // Si debe cambiar contraseña, mostrar componente forzado
  if (showForcedPasswordChange) {
    return <ForcedPasswordChange onSuccess={() => navigate('/app')} />
  }
  return (
    <>
      <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-sm">
          <h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
            Iniciar sesión
          </h2>
        </div>

        <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
          <form className="space-y-2">
            <div>
              <label htmlFor="email" className="block text-sm font-medium leading-6 text-gray-900">
                Usuario
              </label>
              <div className="mt-2">
                <input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="none"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  required
                  className="block w-full rounded-md border-0 py-1.5 px-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div>
              <div className="flex items-center justify-between">
                <label htmlFor="password" className="block text-sm font-medium leading-6 text-gray-900">
                  Contraseña
                </label>
              </div>
              <div className="mt-2">
                <input
                  id="password"
                  name="password"
                  type="password"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  autoComplete="new-password"
                  required
                  className="block w-full rounded-md border-0 py-1.5 px-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>
            <div className={'text-red-600 float-end pb-2'}>{loginError}</div>
            <div>
              <button
                type="button"
                onClick={formik.submitForm}
                className="flex w-full justify-center rounded-md bg-gray-900 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-gray-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-800"
              >
                Iniciar sesión
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  )
}
